import { getRTFInformation } from "@bond-london/graphcms-rich-text";
import classNames from "classnames";
import React from "react";
import { RTF } from "../elements/RTF";
import { Visual } from "../shared/Visual";
import { SectionPaddingClassName } from "../styles";
import { getVisual } from "./Blocks";

export const MultiQuotes: React.FC<{
  collection: Queries.CollectionFragment;
}> = ({ collection: { contents, backgroundShape } }) => {
  const multiQuotesContents = contents.filter(
    (cb) => cb.__typename === "GraphCMS_ContentBlock"
  ) as Array<Queries.ContentBlockFragment>;
  return (
    <section
      data-component="Multi Quotes"
      className={classNames(
        SectionPaddingClassName,
        "page-grid max-width relative"
      )}
    >
      <div className="relative col-start-5 row-start-1 md:col-start-9 lg:col-span-2 lg:col-start-14">
        {backgroundShape && (
          <Visual
            visual={getVisual(backgroundShape)}
            alt=""
            // visualStyle={{ width: "100px" }}
          />
        )}
      </div>
      <div className="col-span-4 col-start-2 grid grid-cols-mobile gap-y-16 md:col-span-full md:grid-cols-desktop-left-14 md:gap-x-desktop">
        {multiQuotesContents.map((quote, index) => {
          const { message, author, image, aside } = quote;
          const cleaned = getRTFInformation(message);
          const jobPosition = getRTFInformation(aside);

          return (
            <div
              key={index}
              className={classNames(
                index % 2 == 0
                  ? "mt-0 md:col-start-3 lg:col-start-3"
                  : "mt-0 md:col-start-9 md:row-start-1 md:mt-250px lg:col-start-9",
                "col-span-4 col-start-2 flex flex-col gap-5 md:col-span-6 md:col-start-2 lg:col-span-6 lg:row-start-1"
              )}
            >
              <h3 className="quotemarks h-10 text-hyacinth">“</h3>
              {cleaned && <RTF content={cleaned} className="h4" />}
              <h3 className="quotemarks text-hyacinth">”</h3>
              <div className="space-between flex gap-x-7">
                <div className="relative">
                  <Visual
                    visual={getVisual(image)}
                    className="h-20 w-20 rounded-full"
                  />
                </div>
                <div className="self-center">
                  {author && <h5 className="h5 text-hyacinth"> {author} </h5>}

                  {jobPosition && (
                    <RTF
                      content={jobPosition}
                      className="h5 self-end text-hyacinth"
                      fixedParagraphClassName={"h5"}
                    />
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};
